import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Constants } from "../../../CommonMethhods/Constants";
import AnalyticMarketCap from "./AnalyticMarketCap";
import AnalyticSector from "./AnalyticSector";
import AnalyticsStock from "./AnalyticsStock";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function AnalyticNew() {
  const storeToken = localStorage.getItem("ssoToken");

  const [analyticData, setAnalyticsData] = useState();
  const [component, setComponent] = useState("sector");

  let clientCode = "";

  const getAnalyticsDataNew = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAnalyticsDetails = await axiosInstance.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.Stock_Analytics_New_URL,
        `"${encPayload}"`,
        
      );
      const response = ApiResDecrypt(getAnalyticsDetails?.data);

      const res = response?.data;
      if (res) {
        setAnalyticsData(res);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getAnalyticsDataNew(clientCode);
    }
  }, []);

  const handleOnChange = (e) => {
    if (e.target.value === "sector") {
      setComponent("sector");
    } else if (e.target.value === "stocks") {
      setComponent("stocks");
    } else {
      setComponent("marketcap");
    }
  };

  const accountDetailEquity = analyticData?.account[0].per;
  // const accountDetailDebt = analyticData?.account[1].per;

  return (
    <div className="card-box analytics bottom-25">
      <div className="card-title">
        <h2 className="small-title">{Constants.Analytics}</h2>
      </div>
      <div className="head">
        <div className="leftHead">
          <div className="firstData">
            {Constants.Equity}: {accountDetailEquity}%
          </div>
          {/* <div className="firstData">
            {Constants.Debt}: {accountDetailDebt}%
          </div> */}
        </div>
        <div className="rightHead">
          {/* <div className="firstRData">As on: Jan 31,2023</div> */}
          {/* <div className="dataRight">View allocation % By</div> */}
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="dropdown-filter displayFlex">
              <div className="dataRight">{Constants.view_allocation}</div>

              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={handleOnChange}
              >
                <option value="sector">{Constants.Sector}</option>
                <option value="stocks">{Constants.Stocks}</option>
                <option value="marketcap">{Constants.Market_Cap}</option>
              </Form.Select>
            </div>
          </div>
        </div>
      </div>
      <div className="analytic-bottom">
        {component === "sector" ? (
          <AnalyticSector sector={analyticData?.sector} />
        ) : component === "marketcap" ? (
          <AnalyticMarketCap marketCap={analyticData?.marketCap} />
        ) : (
          <AnalyticsStock stock={analyticData?.compnay} />
        )}
        {/* <AnalyticsStock stock={analyticData?.compnay} />
          <AnalyticMarketCap marketCap={analyticData?.marketCap} />
          <AnalyticSector sector={analyticData?.sector} /> */}
      </div>
    </div>
  );
}

export default AnalyticNew;
